export var AccountTypeEnum = {
    INDIVIDUAL: 'INDIVIDUAL',
    COMPANY: 'COMPANY'
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/enums/accountTypeEnum.js
// module id = 361
// module chunks = 0